import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import * as yup from 'yup';
import { Form, FormikProvider, useFormik } from 'formik';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import Div from '@jumbo/shared/Div';
import { alpha } from '@mui/material/styles';
import { ASSET_IMAGES } from '../../../utils/constants/paths';
import { getAssetPath } from '../../../utils/appHelpers';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import { resetPassword } from 'app/redux/slice/authSlice';
import JumboTextField from '@jumbo/components/JumboFormik/JumboTextField';
const ResetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const validationSchema = yup.object({
    email: yup
      .string()
      .required('Pleas Enter your email')
      .email('Please Enter a valid email'),
  });

  const handleSave = (data) => {
    dispatch(resetPassword(data))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: 'success',
          });
          navigate('/login');
        } else {
          enqueueSnackbar(res.data?.responseMessage, { variant: 'error' });
        }
      });
  };

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    // validateOnChange: false,
    validationSchema,
    onSubmit: () => handleSave(formik?.values),
  });

  const { handleSubmit } = formik;
  return (
    <Div sx={{ width: 720, maxWidth: '100%', margin: 'auto', p: 4 }}>
      <Card
        sx={{
          display: 'flex',
          minWidth: 0,
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        <CardContent
          sx={{
            flex: '0 1 300px',
            position: 'relative',
            background: `#0267a0 url(${getAssetPath(
              `${ASSET_IMAGES}/tsm-logo-2.png`,
            )}) no-repeat center`,
            backgroundSize: 'cover',
            '&::after': {
              display: 'inline-block',
              position: 'absolute',
              content: `''`,
              inset: 0,
              backgroundColor: alpha('#000000', 0.6),
            },
          }}
        >
          <Div
            sx={{
              display: 'flex',
              minWidth: 0,
              flex: 1,
              flexDirection: 'column',
              color: 'common.white',
              position: 'relative',
              zIndex: 1,
              height: '100%',
              minHeight: { md: 320 },
            }}
          >
            <Div sx={{ mb: 2 }}>
              <Typography
                variant={'h3'}
                color={'inherit'}
                fontWeight={500}
                mb={3}
              >
                Reset Password
              </Typography>
              <Typography variant={'body1'} mb={1} sx={{ maxWidth: 270 }}>
                Enter your email id to receive an email with the link to proceed
                with resetting your password.
              </Typography>
            </Div>
            <Div sx={{ mt: 'auto' }}>
              <Link href="#" underline="none" sx={{ display: 'inline-flex' }}>
                <img src={`${ASSET_IMAGES}/tsm-logo-2.png`} alt="Logo" />
              </Link>
            </Div>
          </Div>
        </CardContent>
        <CardContent sx={{ flex: 1, p: 4 }}>
          <FormikProvider value={formik}>
            <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Div
                sx={{
                  display: 'flex',
                  minWidth: 0,
                  flex: 1,
                  flexDirection: 'column',
                  height: '100%',
                }}
              >
                <Div sx={{ mb: 2 }}>
                  <Div sx={{ mt: 1, mb: 3 }}>
                    <JumboTextField
                      fullWidth
                      name="email"
                      label="Email"
                      required
                    />
                  </Div>
                  <Button
                    variant="contained"
                    buttonLabel={'Send'}
                    onClick={formik.handleSubmit}
                  >
                    Send
                  </Button>
                </Div>
                <Typography variant={'body1'} mt={'auto'}>
                  <Link href={'/login'} underline={'none'}>
                    Back to login?
                  </Link>
                </Typography>
              </Div>
            </Form>
          </FormikProvider>
        </CardContent>
      </Card>
    </Div>
  );
};
export default ResetPassword;
